import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';

const MainButton = ({ path, text, type }) => {
  return (
    <div data-test-id="mainButton">
      <a className={styles.link} href={path}>
        <div className={`${styles.container} ${styles[type]}`}>
          <span className={styles.text}>{text}</span>
        </div>
      </a>
    </div>
  );
};

MainButton.defaultProps = {
  path: '/',
  text: 'Click Here',
  type: 'default'
};

MainButton.propTypes = {
  path: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string
};

export default MainButton;
